import { createContext, useState } from "react";

export const PatientContext = createContext();

const PatientContextProvider = ({ children }) => {
  const [patients, setPatients] = useState([]);

  // Fetch all patients (simulate API call)
  const fetchPatients = async () => {
    
    return patients;
  };

  // Add a new patient
  const addPatient = (patient) => {
    setPatients(prev => [...prev, patient]);
  };

  // Update a patient by id
  const updatePatient = (id, updated) => {
    setPatients(prev => prev.map(p => p.id === id ? { ...p, ...updated } : p));
  };

  // Remove a patient by id
  const removePatient = (id) => {
    setPatients(prev => prev.filter(p => p.id !== id));
  };

  return (
    <PatientContext.Provider value={{
      patients,
      setPatients,
      fetchPatients,
      addPatient,
      updatePatient,
      removePatient
    }}>
      {children}
    </PatientContext.Provider>
  );
};

export { PatientContextProvider };
